const preTitle = {
  fontFamily: 'SackersGothicStd, sans-serif',
  fontSizeSmall: '14px',
  fontSizeMedium: '16px',
  lineHeightSmall: '22px',
  lineHeightMedium: '24px'
}

const title = {
  fontFamily: 'SackersGothicStd, sans-serif',
  fontSizeSmall: '24px',
  fontSizeMedium: '32px',
  lineHeightSmall: '32px',
  lineHeightMedium: '40px',
  lineHeightLarge: '52px',
  widthSmall: '308px',
  widthMedium: '411px'
}

const textStyles = {
  name: '3',
  type: 'Paragraph'
}


export default {
  preTitle,
  title,
  textStyles
}
